import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";
import { IonicModule } from '@ionic/angular';
import {
  AmbassadorProductsTableComponent
} from "../embajadores/ambassador-products-table/ambassador-products-table.component";
import { BindingOptionsModule } from "../home-new/binding-options/binding-options.module";
import { OptionsButtonModule } from "../home-new/options-button/options-button.module";
import { PipesModule } from "../pipes/pipes.module";
import { QtyStepperModule } from "../shared/shop/qty-stepper/qty-stepper.module";
import { AcceptanceModalComponent } from './acceptance-modal/acceptance-modal.component';
import { ActionsMenuComponent } from "./actions-menu/actions-menu.component";
import { AdsSubscriptionModalComponent } from './ads-subscription-modal/ads-subscription-modal.component';
import { AlertModalComponent } from './alert-modal/alert-modal.component';
import { BlankSheetsModalComponent } from "./blank-sheets-modal/blank-sheets-modal.component";
import { BrowserShareComponent } from './browser-share/browser-share.component';
import { ChangeTextFieldModalComponent } from "./change-text-field-modal/change-text-field-modal.component";
import { CircularProgressBarComponent } from "./circular-progress-bar/circular-progress-bar.component";
import { ClientTrackingDataComponent } from "./client-tracking-data/client-tracking-data.component";
import { CloseModalButtonComponent } from "./close-modal-button/close-modal-button.component";
import { ConfirmCommentModalComponent } from "./confirm-comment-modal/confirm-comment-modal.component";
import { ConfirmModalCartComponent } from './confirm-modal-cart/confirm-modal-cart.component';
import { ConfirmModalComponent } from "./confirm-modal/confirm-modal.component";
import { ConfirmPopoverComponent } from './confirm-popover/confirm-popover.component';
import { CoverSettingsComponent } from "./cover-settings/cover-settings.component";
import {
  TooltipInfoDespaginationComponent
} from "./cover-settings/tooltip-info-despagination/tooltip-info-despagination.component";
import { DefaultAddressWarningComponent } from './default-address-warning/default-address-warning.component';
import { DeleteAddressWarningComponent } from './delete-address-warning/delete-address-warning.component';
import { FaqSidebarComponent } from './faq-sidebar/faq-sidebar.component';
import { FolderActionsMenuComponent } from './folder-actions-menu/folder-actions-menu.component';
import { GroupedBindingSelectorComponent } from "./grouped-binding-selector/grouped-binding-selector.component";
import { ImageModalComponent } from './image-modal/image-modal.component';
import {
  IncompatibleLaminationAlertComponent
} from "./incompatible-lamination-alert/incompatible-lamination-alert.component";
import {
  IndividualBindingOptionsModalComponent
} from "./individual-binding-options-modal/individual-binding-options-modal.component";
import {
  IndividualSettingsComponent
} from "./individual-settings/individual-settings.component";
import { InfoDespaginationModalComponent } from "./info-despagination-modal/info-despagination-modal.component";
import { InfoPasarPaginaComponent } from './info-pasar-pagina/info-pasar-pagina.component';
import {
  InfoProgramacionDidacticaModalComponent
} from "./info-programacion-didactica-modal/info-programacion-didactica-modal.component";
import { LoginCardComponent } from './login-card/login-card.component';
import { MessageComponent } from './message/message.component';
import { MobileToolbarComponent } from "./mobile-toolbar/mobile-toolbar.component";
import { ModifyContactDataComponent } from './modify-contact-data/modify-contact-data.component';
import { OnlyNumberDirective } from './only-number.directive';
import { OrdersBlockedAlertComponent } from "./orders-blocked-alert/orders-blocked-alert.component";
import { OutOfStockPopoverComponent } from './out-of-stock-popover/out-of-stock-popover.component';
import { PreventClickOnConditionDirective } from './prevent-click-on-condition.directive';
import { PreventDoubleClickDirective } from './prevent-double-click.directive';
import { PrintPermissionPolicyComponent } from "./print-permission-policy/print-permission-policy.component";
import { FileDetailsComponent } from './print-product-modal/file-details/file-details.component';
import { PrintProductModalComponent } from './print-product-modal/print-product-modal.component';
import { PrintSettingsLabelsComponent } from "./print-settings-labels/print-settings-labels.component";
import { ProductQtyComponent } from './product-qty/product-qty.component';
import { SearchBarComponent } from "./search-bar/search-bar.component";
import { ShopCardComponent } from './shop-card/shop-card.component';
import { SnowComponent } from './snow.component';
import { UploadFilePopoverComponent } from './upload-file-popover/upload-file-popover.component';
import { ValidateTaxId } from './validate-taxId.directive';
import { VideoPlayerModalComponent } from "./video-player-modal/video-player-modal.component";


@NgModule({
  declarations: [
    ProductQtyComponent,
    PreventDoubleClickDirective,
    OnlyNumberDirective,
    BrowserShareComponent,
    InfoPasarPaginaComponent,
    LoginCardComponent,
    MessageComponent,
    SnowComponent,
    AcceptanceModalComponent,
    ConfirmPopoverComponent,
    ShopCardComponent,
    ValidateTaxId,
    UploadFilePopoverComponent,
    AlertModalComponent,
    CircularProgressBarComponent,
    SearchBarComponent,
    MobileToolbarComponent,
    AmbassadorProductsTableComponent,
    CloseModalButtonComponent,
    PrintPermissionPolicyComponent,
    CloseModalButtonComponent,
    BlankSheetsModalComponent,
    PreventClickOnConditionDirective,
    PrintSettingsLabelsComponent,
    ConfirmModalComponent,
    ChangeTextFieldModalComponent,
    IndividualSettingsComponent,
    IndividualBindingOptionsModalComponent,
    InfoProgramacionDidacticaModalComponent,
    ConfirmModalCartComponent,
    CoverSettingsComponent,
    TooltipInfoDespaginationComponent,
    VideoPlayerModalComponent,
    ConfirmCommentModalComponent,
    OrdersBlockedAlertComponent,
    GroupedBindingSelectorComponent,
    ClientTrackingDataComponent,
    ActionsMenuComponent,
    DefaultAddressWarningComponent,
    AdsSubscriptionModalComponent,
    DeleteAddressWarningComponent,
    IncompatibleLaminationAlertComponent,
    ModifyContactDataComponent,
    FaqSidebarComponent,
    PrintProductModalComponent,
    FolderActionsMenuComponent,
    FileDetailsComponent,
    ImageModalComponent,
    InfoDespaginationModalComponent,
    OutOfStockPopoverComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    PipesModule,
    TooltipModule,
    QtyStepperModule,
    OptionsButtonModule,
    BindingOptionsModule
  ],
  exports: [
    ProductQtyComponent,
    PreventDoubleClickDirective,
    OnlyNumberDirective,
    BrowserShareComponent,
    InfoPasarPaginaComponent,
    LoginCardComponent,
    MessageComponent,
    SnowComponent,
    AcceptanceModalComponent,
    ConfirmPopoverComponent,
    ShopCardComponent,
    ValidateTaxId,
    UploadFilePopoverComponent,
    CircularProgressBarComponent,
    SearchBarComponent,
    MobileToolbarComponent,
    AlertModalComponent,
    AmbassadorProductsTableComponent,
    CloseModalButtonComponent,
    PreventClickOnConditionDirective,
    PrintSettingsLabelsComponent,
    ClientTrackingDataComponent,
    ActionsMenuComponent,
    DefaultAddressWarningComponent,
    AdsSubscriptionModalComponent,
    DeleteAddressWarningComponent,
    ModifyContactDataComponent,
    FaqSidebarComponent,
    FolderActionsMenuComponent,
    OutOfStockPopoverComponent
  ]
})
export class ComponentsModule {
}
